import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

import SpeakWithAgent from '../child-blocks/SpeakWithAgent';

interface IProps {
    stateName?: string | undefined;
    planYear?: string | undefined;
    zipFormHeading?: string | undefined;
    zipFormMainCtaCopy?: string | undefined;
    zipFormSecondaryCtaCopy?: string | undefined;
    zipFormQaValue?: string;
}

const CallAgentWithZip = ({
    stateName = 'your state',
    planYear = '',
    zipFormHeading = '',
    zipFormMainCtaCopy = '',
    zipFormSecondaryCtaCopy = '',
    zipFormQaValue = '',
}: PropsWithChildren<IProps>) => {
    const heading =
        zipFormHeading || `Call an eHealth licensed insurance agent with expertise in ${stateName}`;
    return (
        <div className="pb-2 md:pb-6 lg:pb-10 lg:px-4">
            <section className={classNames('hero-paid-search-legacy-style-vertical-layout')}>
                <h2 className="mb-custom">
                    <span className="text-16 leading-16 font-semibold md:text-24 md:leading-32 md:font-bold lg:text-28 lg:leading-32">
                        {heading}
                    </span>
                </h2>

                <div className="rounded-lg flex justify-center pb-2 md:pb-0">
                    <div className="max-w-screen-xs md:max-w-screen-sm lg:max-w-screen-md w-full">
                        <SpeakWithAgent
                            headingCopy=""
                            fromComponentName="Hero Paid Seach: Call Agent with Zip"
                            btnStyle="primary"
                        />

                        <p className="text-center text-14 leading-20 md:text-16 md:leading-24 lg:text-18 lg:leading-28 mt-8 mb-3 lg:my-6">
                            Or enter your ZIP to get started online
                        </p>

                        <div className="block md:hidden">
                            <ZipForm
                                buttonTitle="See plans in my area"
                                buttonTitleMobile="See plans in my area"
                                buttonWaLink="Hero Call Agent With Zip: see plans in my area"
                                qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                                opts={{
                                    btnStyle: 'secondary',
                                    useWideLayout: true,
                                }}
                                redirect={{
                                    toUrl: process.env.GATSBY_EHMP_URL,
                                    delay: 500,
                                }}
                            />
                        </div>
                        <div className="hidden md:block">
                            <ZipForm
                                buttonTitle="See plans in my area"
                                buttonTitleMobile="See plans in my area"
                                buttonWaLink="Hero Call Agent With Zip: see plans in my area"
                                qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                                opts={{
                                    btnStyle: 'primary',
                                    useWideLayout: true,
                                }}
                                redirect={{
                                    toUrl: process.env.GATSBY_EHMP_URL,
                                    delay: 500,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CallAgentWithZip;
